import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../common/store'
import { APCartItem, APFrameDetailsType } from './ap.types'

export interface ApCartState {
  items: APCartItem[]
  contactName: string
  department: string
  addressStreet: string
  addressSuburb: string
  addressState: string
  addressPostCode: string
  phoneNo: string
  faxNo: string
  email: string
  instructions: string
}

const initialState: ApCartState = {
  items: [],
  contactName: '',
  department: '',
  addressStreet: '',
  addressSuburb: '',
  addressState: '',
  addressPostCode: '',
  phoneNo: '',
  faxNo: '',
  email: '',
  instructions: '',
}

export const AP_CART = 'apCart'

export const apCartSlice = createSlice({
  name: AP_CART,
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<APFrameDetailsType>) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      if (state.items.filter(item => item.frame.id === action.payload.id).length === 0) {
        state.items.push(createCartItem(action.payload))
      }
    },
    removeFromCart: (state, action: PayloadAction<APFrameDetailsType>) => {
      state.items = state.items.filter(item => item.frame.id !== action.payload.id)
    },
    updateCartItem: (state, action: PayloadAction<APCartItem>) => {
      const index = state.items.findIndex(item => item.frame.id === action.payload.frame.id)
      if (index >= 0) {
        state.items[index] = action.payload
      }
    },
    clearCart: (state) => {
      state.items.length = 0
    },
    updateCartDetail: (state, action: PayloadAction<{ name: string, value: any }>) => {
      return { ...state, [action.payload.name]: action.payload.value }
    },
  },
})

const createCartItem = (frame: APFrameDetailsType): APCartItem => {
  return {
    frame: frame,
    product: 'tiff600',
  }
}

export const {
  addToCart,
  removeFromCart,
  updateCartItem,
  clearCart,
  updateCartDetail,
} = apCartSlice.actions

export const selectCart = (state: RootState) => state[AP_CART]
export const selectCartItems = (state: RootState) => state[AP_CART].items
